import { j as w } from "./atoms-v218.js";
import { useRef as h, useState as x, useMemo as v } from "react";
import { useTheme as O } from "styled-components";
import { useFloating as R, useHover as b, useFocus as j, useDismiss as F, useRole as k, useInteractions as A, FloatingArrow as E } from "./atoms-v280.js";
import { offset as I } from "./atoms-v284.js";
import { flip as M, shift as U, autoUpdate as C } from "./atoms-v283.js";
import { arrow as D } from "./atoms-v2719.js";
function G({
  colorTheme: t = "light",
  initialOpen: l = !1,
  placement: a = "top"
} = {}) {
  const s = h(null), o = O(), [c, p] = x(l), n = c, r = p, i = R({
    middleware: [I(10), M({ padding: 10 }), U({ padding: 10 }), D({ element: s })],
    onOpenChange: r,
    open: n,
    placement: a,
    whileElementsMounted: C
  }), e = i.context, f = b(e, {
    enabled: !0,
    move: !1
  }), m = j(e, {
    enabled: !0
  }), d = F(e), g = k(e, { role: "tooltip" }), u = A([f, m, d, g]);
  return v(
    () => ({
      Arrow: /* @__PURE__ */ w.jsx(
        E,
        {
          context: e,
          fill: o == null ? void 0 : o.get(`tokens.surface.${t}.backgroundInverse`),
          height: 6,
          ref: s,
          width: 12
        }
      ),
      arrowRef: s,
      colorTheme: t,
      open: n,
      setOpen: r,
      ...u,
      ...i
    }),
    [e, o, t, n, r, u, i]
  );
}
export {
  G as useTooltip
};
